const modules = import.meta.glob<{ default: string }>('./kersko-*.jpg', { eager: true });

export const kerskoImages = Object.keys(modules)
  .sort((a, b) => {
    const na = parseInt(a.match(/kersko-(\d+)/)?.[1] || '0');
    const nb = parseInt(b.match(/kersko-(\d+)/)?.[1] || '0');
    return na - nb;
  })
  .map(k => modules[k].default);

import fp3d from './floorplan-3d.jpg';
import fp2d from './floorplan-2d.jpg';

export const kerskoFloorPlans = [
  { image: fp3d, label: "Půdorys – 3D" },
  { image: fp2d, label: "Půdorys – 2D" },
];
